import _ from 'lodash';

class Grid {
  constructor() {
    this.config = null;
    this.ganttInstance = null;
  }

  init(instance, config) {
    this.ganttInstance = instance;
    this.config = config;
  }

  renderRow(item) {
    const el = document.createElement('div');

    el.className = `gantt_row workload_row${item.user_id ? ' workload_row_real_resource' : ' workload_row_material_resource'}${item.selected ? ' selected' : ''}`;
    if (item.separator) {
      el.className += ' separator';
    }
    if (item.firstChild) {
      el.className += ' first';
    }
    if (item.lastChild) {
      el.className += ' last';
    }
    if (item.unassigned) {
      el.className += ' unassigned';
    }
    if (item.opened) {
      el.className += ' open';
    }
    el.style.height = `${this.getWorkloadItemHeight(item.id)}px`;
    el.style.lineHeight = `${this.getWorkloadItemHeight(item.id)}px`;
    el.style.position = 'absolute';
    el.style.top = `${this.getWorkloadItemTop(item.id)}px`;

    el.innerHTML = `${item.tasksLayout ? '' : '<div class=\'arrow\'></div>'}
                    <div class='workload_row_photo' style="background-image:url(${item.photo || 'https://cdn.ganttpro.com/app/imgs/default/default-ava.svg'})"></div>
                    <div class='workload_row_name'>${_.escape(item.name)}</div>`;

    el.onclick = e => {
      if (e && e.target && e.target.closest('.workload_row_calendar')) {
        this.ganttInstance.callEvent('onClickResourceCalendarIcon', [item.resource_id]);
      } else if (!item.tasksLayout) {
        this.ganttInstance.callEvent('onClickWorkloadResourceRow', [item.id]);
      }
    };

    if (item.tasksLayout) {
      el.innerHTML = '<div class=\'empty\'></div>';
      el.className += ' tasks';
    } else {
      el.setAttribute('data-resource-grid-id', item.id);

      const overloadColumn = this.ganttInstance.config.columns.find(o => o.name === 'overload');

      if (this.ganttInstance.ganttDataApi.getOverloadedResources({ resourceId: item.resource_id, taskIds: item.tasksByGanttId.map(o => o.task_id) }) && !overloadColumn?.hide) {
        el.innerHTML += `<div class='workload_row_overload tooltip-gantt' data-key='overload_tooltip_workload'>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <use xmlns:xlink="http://www.w3.org/2000/svg"
                    xlink:href="#icons/regular/24/resource"
                    href="#icons/regular/24/resource"
                ></use>
          </svg>
        </div>`;
      }
      if (item.accessToPersonalCalendar && !item.unassigned) {
        // el.innerHTML += '<div class=`workload_row_calendar tooltip-gantt` data-key=`workload_calendar_tooltip`></div>';
        el.innerHTML += `<div class='workload_row_calendar tooltip-gantt gp_autotest_webix_workload_resource_item_btn_calendar' 
          data-key='workload_calendar_tooltip'  
          data-position='top' data-align='right'>
            <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path fill='#757575' d='M8 12h8v1H8zM8 15h4v1H8zM7 4h1v2.13333H7zM16 4h1v2.13333h-1zM5 9h14v1.06667H5z'/>
              <rect x='.5' y='.5' width='13' height='13' rx='1.5' transform='translate(5 6)' stroke='#757575'/>
            </svg>
          </div>`;
      }
    }

    return el;
  }

  changeCssClassForGridRow(rowId, cssClass, removeClassList) {
    const grid = this.ganttInstance.$ui.getView('workloadGrid').$grid;
    const allRows = grid.querySelectorAll('.workload_row');

    allRows.forEach(el => {
      if (removeClassList) {
        removeClassList.forEach(cl => {
          el.classList.remove(cl);
        });

        return;
      }

      const id = el.getAttribute('data-resource-grid-id');

      el.classList[String(rowId) === id ? 'add' : 'remove'](cssClass);
    });
  }

  getWorkloadItemHeight(itemId) {
    if (this.config.resourcesLayout[itemId]) {
      return this.config.resourcesLayout[itemId].visibleHeight || this.config.resourcesLayout[itemId].height;
    }

    return 0;
  }

  getWorkloadItemTop(itemId) {
    if (this.config.resourcesLayout[itemId]) {
      return this.config.resourcesLayout[itemId].top;
    }

    return 0;
  }

  toggleGrid() {
    const workloadGrid = this.ganttInstance.$ui.getView('workloadGrid');

    if (!workloadGrid) {
      return;
    }

    workloadGrid.$parent.$config.hidden = !workloadGrid.$parent.$config.hidden;
  }
}

export default new Grid();
